import React from "react";
import styles from "./Primary.module.scss";
import SVG from "react-inlinesvg";
import OvalSpinner from "../../OvalSpinner";
import { TYPE_BUTTON } from "../types";

const WIDTH__DEFAULT = "16px";

const HEIGHT_DEFAULT = "16px";

const COLOR_DEFAULT = "#FFF";

const BACKGROUND_DEFAULT = "#233348";

const FONT_COLOR_DEFAULT = "#F9F9F9";

const BACKGROUND_HOVER = "#2a3e53";

const COLOR_IS_LOADING = "#213448";

export default function Primary(PrimaryProps) {
  const {
    onClick,
    isLoading,
    type,
    disabled,
    label,
    icon,
    backgroundColor,
    backgroundColorHover,
    textColor,
    textColorHover,
    withShadow
  } = PrimaryProps;

  const ContainerStyled = {
    "--backgroundCustom": backgroundColor ?? BACKGROUND_DEFAULT,
    "--backgroundHoverCustom": backgroundColorHover ?? BACKGROUND_HOVER,
  };

  const TextStyle = {
    "--colorCustom": textColor ?? COLOR_DEFAULT,
    "--colorHoverCustom": textColorHover ?? COLOR_DEFAULT,
  };

  const ContainerClassName = `${styles.primaryButton} ${
    withShadow ? styles.shadow : ""
  }`;
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type ?? TYPE_BUTTON.BUTTON}
      className={ContainerClassName}
      style={ContainerStyled}
    >
      {isLoading && (
        <OvalSpinner height={HEIGHT_DEFAULT} width={WIDTH__DEFAULT} />
      )}
      {icon && (
        <div className={styles.iconWrapper}>
          <SVG src={icon} />
        </div>
      )}
      <span className={styles.textWrapper} style={TextStyle}>
        {label}
      </span>
    </button>
  );
}
